import React from 'react';
import styled from 'styled-components';

const imageSize = '4.375rem';

export default styled(({ className }) => <div className={className} />)`
  align-self: center;
  justify-self: center;
  background: transparent url(${({ image }) => image}) no-repeat center center;
  width: ${({ size }) => size || imageSize};
  height: ${({ height }) => height || imageSize};
  background-size: cover;
  border-radius: 0.25rem;

  &:hover {
    box-shadow: ${({ disabled }) => (disabled ? 'none' : '0 1px 3px -1px black')};
  }
  &:active {
    box-shadow: none;
  }
`;
